import {  Grid, TextField, Button, IconButton } from '@material-ui/core';
import { Dialog, DialogTitle, DialogContent } from '@material-ui/core/';
import { makeStyles } from '@material-ui/core/styles';
import React, { useState } from 'react';
import CloseIcon from '@material-ui/icons/Close';
//import Alert from '@material-ui/lab/Alert';
import StatusDisplay from './StatusDisplay'

const useStyles = makeStyles((theme) => ({
    signinbtn: {
        fontFamily: 'Open Sans',
        fontWeight: 400,
        fontSize: 18,
        backgroundColor: "#1867B8",
        width: 160,
        height: 40,
        color: '#FFFFFF',
        margin: 20,
        borderRadius: 0,
        '&:hover': {
            backgroundColor: "#1867B8",
            color: '#FFFFFF',
        }

    }
}));

const ResetPasswordDialog = ( {open, signinlabel ,okCallback,closeCallback
        ,isRunning,successMessage,setSuccessMessage,error,setError} )=>{

    const classes = useStyles();
    let [newPassword, setNewPassword ] = useState("");
    let [newPassword2, setNewPassword2 ] = useState("");


    return (
        <Dialog fullWidth={true} open={open} maxWidth='sm' disableBackdropClick disableEscapeKeyDown  aria-labelledby="max-width-dialog-title">
            <Grid item xs={12} container>
                <Grid item xs={11}> <DialogTitle id="verify-authapp-user-dilaog">{signinlabel.ResetPasswordLabels}</DialogTitle> </Grid>
                <Grid item xs={1}> <IconButton onClick={()=>{closeCallback();}}> <CloseIcon /> </IconButton> </Grid>
            </Grid>
        <DialogContent>  
            <div style={{ marginBottom: '20px', marginLeft: '10px', marginRight: '10px', height: '350px', width: '420px' }}>                                  
                <StatusDisplay isRunning={isRunning}  successMessage={successMessage} setSuccessMessage={setSuccessMessage} error={error} setError={setError} ></StatusDisplay>
                <Grid container justify="center">
                    <div className={classes.logindiv}>
                        <TextField id="newPassword" autoFocus name="newPassword" variant="outlined" type="password" label={signinlabel.NewPasswordLabels}
                            onChange={(e=>{ setNewPassword( e.target.value) })} value={newPassword}
                            InputProps={{ classes: { input: classes.txtboxInput } }}
                            style={{ marginBottom: '10px' }}
                                />

                        <TextField id="newPassword2" name="newPassword2" variant="outlined" type="password" label={signinlabel.ConfirmNewPasswordLabels}
                            onChange={(e=>{ setNewPassword2( e.target.value) })} value={newPassword2}
                            InputProps={{ classes: { input: classes.txtboxInput } }}
                            style={{ marginBottom: '10px' }}
                            />
                        <br></br>
                        <label className={classes.passwordhintLabel} style={{ width: '300px' }}>{signinlabel.PasswordHintLabels}</label>
                        <Button variant="contained" color="primary" onClick={()=>{ okCallback(newPassword,newPassword2) }} className={classes.signinbtn}> {signinlabel.SignInLabels} </Button>

                    </div>
                </Grid>
            </div>
        </DialogContent>
    </Dialog>
    );
}
export default ResetPasswordDialog;